import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class MiniAppErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('MiniApp Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div 
          style={{
            minHeight: '100vh',
            backgroundColor: '#2d3748',
            color: '#f7fafc',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: '20px',
            textAlign: 'center',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}
        >
          <h1 style={{ color: '#e2c044', marginBottom: '20px' }}>
            BroMentum Mini-App Error
          </h1>
          <p style={{ color: '#cbd5e0', marginBottom: '20px' }}>
            The mini-app encountered an error. Please try refreshing.
          </p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              background: '#e2c044',
              color: '#2d3748',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Refresh
          </button>
          {this.state.error && (
            <details style={{ marginTop: '20px', maxWidth: '600px' }}>
              <summary style={{ cursor: 'pointer', color: '#9ca3af' }}>
                Error Details
              </summary>
              <pre style={{
                background: '#1a202c',
                padding: '15px',
                borderRadius: '5px',
                marginTop: '10px',
                textAlign: 'left',
                fontSize: '12px',
                overflow: 'auto',
                color: '#e2e8f0'
              }}>
                {this.state.error.message}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default MiniAppErrorBoundary;